import { isBillingMenuVisible, isMenuRouteVisible } from '../../router'
import navigationRoutes, { type INavigationRoute } from './NavigationRoutesDesktop'

const personalHiddenRouteNames = ['administracion', 'tax']
const hiddenRouteNames = ['tax', 'reminders']

function fundsBesideCategories(items: INavigationRoute[], business: boolean) {
  if (!business) return items
  const from = items.findIndex((item) => item.name === 'funds')
  const categories = items.findIndex((item) => item.name === 'categories')
  if (from < 0 || categories < 0) return items
  const next = items.slice()
  const [funds] = next.splice(from, 1)
  next.splice(
    next.findIndex((item) => item.name === 'categories'),
    0,
    funds,
  )
  return next
}

export function visibleNavigationRoutes(options: {
  personal: boolean
  business: boolean
  billingEnabled: boolean
}): INavigationRoute[] {
  const { personal, business, billingEnabled } = options
  return fundsBesideCategories(
    navigationRoutes.routes
    .filter((item) => !hiddenRouteNames.includes(item.name))
    .filter((item) => isMenuRouteVisible(item.name, personal))
    .filter((item) => item.name !== 'settings' || (business && billingEnabled))
    .filter((item) => !personal || !personalHiddenRouteNames.includes(item.name))
    .map((item) => ({
      ...item,
      children: item.children?.filter(
        (child) =>
          isMenuRouteVisible(child.name, personal) &&
          isBillingMenuVisible(child.name, billingEnabled, personal) &&
          (billingEnabled || child.name !== 'users'),
      ),
    })),
    business,
  )
}
